import LogRocket from 'logrocket'
import { UserTypeTeacher, UserTypeStudent, UserTypeMentor, UserTypeJudge, UserTypeJacAdmin, UserTypeJudgingAppAdmin } from '@/mixins/user-types'
import chmln from '@chamaeleonidae/chmln'

const utils = {
  trackLogrocketUser: (user) => {
    LogRocket.identify(user.uuid, {
      name: user.fullName,
      email: user.email,
      username: user.userName,
      appName: process.env.APP_NAME
    })
  },
  trackChameleonUser: (user) => {
    if (process.env.APP_NAME !== 'Make' && process.env.APP_NAME !== 'Neweng') {
      chmln.identify(user.id, {
        email: user.email,
        name: user.fullName,
        role: user.type,
        isStudent: user.type.includes(UserTypeStudent),
        isTeacher: user.type.includes(UserTypeTeacher),
        isMentor: user.type.includes(UserTypeMentor),
        isJudge: user.type.includes(UserTypeJudge),
        isJACAdmin: user.type.includes(UserTypeJacAdmin),
        isJudgingAppAdmin: user.type.includes(UserTypeJudgingAppAdmin),
        appName: process.env.APP_NAME
      })
    }
  }
}

export default utils
